import { render, staticRenderFns } from "./logzio.vue?vue&type=template&id=1fbc3bc2&"
import script from "./logzio.vue?vue&type=script&lang=js&"
export * from "./logzio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports